import React from 'react';
import { Bok } from 'lib/templates/Foundation.BOKF.model';
import LinkWrapper from 'helpers/LinkWrapper/LinkWrapper';
import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export type LinkChipsProps = {
  fields: {
    children: Bok.BaseTypes.SingleLink[];
  };
};

const LinkChips = (props: LinkChipsProps): JSX.Element => {
  const items = props?.fields?.children;
  return (
    <section className="container flex flex-col mt-6">
      {items && items.length > 0 && (
        <ul className="flex flex-wrap gap-2 justify-center">
          {items.map((item: Bok.BaseTypes.SingleLink, key) => (
            <li key={key} className="flex">
              <LinkWrapper
                field={item.fields?.Link as LinkField}
                className="btn-link-chips"
                role="link"
              />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default LinkChips;
